import { ApiError } from '@/api/envelope';

export type DocumentField = 'title' | 'description' | 'categoryId';

/**
 * A 422 the backend sends about one field of a document in a sentence that
 * `applyServerErrors` cannot read as labelled: `category_id: No category with
 * id ... in this organization`, "A document needs a title", "The title is
 * longer than 100 characters", "The description is longer than ...". Read
 * here so each lands under its field (spec: "the message is shown under that
 * field and the field takes focus"); anything else is left to the caller.
 */
export function documentFieldRefusal(
  error: unknown,
): { field: DocumentField; message: string } | null {
  if (!(error instanceof ApiError) || error.status !== 422 || !error.apiError) {
    return null;
  }
  const sentence = error.apiError;
  if (sentence.startsWith('category_id: ')) {
    // The backend's words name the id, which means nothing to a person.
    return {
      field: 'categoryId',
      message: 'That category no longer exists. Choose another.',
    };
  }
  if (/^(A document needs a title|The title )/.test(sentence)) {
    return { field: 'title', message: sentence };
  }
  if (sentence.startsWith('The description ')) {
    return { field: 'description', message: sentence };
  }
  return null;
}
